import { BigNumber, Contract } from 'ethers';
import { useCallback, useEffect, useState } from 'react';
import {
  Info
} from '../tomb-finance/types';
import config from '../config';
import useTombFinance from './useTombFinance';
import useChainId from './useChainId';

const useLionBombInfo = (contract: Contract) => {
  const info: Info= {
    ticketPrice: BigNumber.from(0),
    currentBets: 0,
    epochFinish: 0,
    epochTimer: 0,
    currentWinner: '',
    burnFee: 0,
    nextBombFee: 0,
    minimumTimer: 0,
    jackpot: BigNumber.from(0)
  }

  const [lionBombInfo, setInfo] = useState(info);
  const tombFinance = useTombFinance();
  const {chainId} = useChainId()

  const fetchInfo = useCallback(async () => {
    const contractInfo=await tombFinance.getLionBombInfo(contract);
    setInfo(contractInfo);
  }, [tombFinance]);

  useEffect(() => {
    fetchInfo().catch((err) => console.error(`Failed to fetch token balance: ${err.stack}`));
    let refreshInterval = setInterval(fetchInfo, config[chainId]?.refreshInterval);
    return () => clearInterval(refreshInterval);
  }, [fetchInfo, tombFinance]);

  return lionBombInfo;
};

export default useLionBombInfo;
